export default __webpack_public_path__ + "static/media/29.7f6a7616.jpg";